/**
 * Auto-detected local agent types for bridge reports. Each kind’s detection logic lives
 * alongside its ACP client in `clients/*-acp-client.ts` (`detectLocalAgentPresence`).
 */

import { yieldToEventLoop } from '../runtime/yield-to-event-loop.js';
import { isCliImmediateShutdownRequested } from '../runtime/cli-process-interrupt.js';
import * as claudeCodeAcp from './acp/clients/claude-code-acp-client.js';
import * as codexAcp from './acp/clients/codex-acp-client.js';
import * as cursorCliAcp from './acp/clients/cursor/cursor-acp-client.js';
import * as kiroAcp from './acp/clients/kiro-acp-client.js';

/** Order matches historical reporting; keep stable for UI that diffs lists. */
const LOCAL_AGENT_ACP_MODULES = [
  cursorCliAcp,
  codexAcp,
  kiroAcp,
  claudeCodeAcp,
] as const;

/** Backend local-agent type strings that were detected on this machine (best-effort). */
export async function detectLocalAgentTypes(): Promise<string[]> {
  try {
    if (isCliImmediateShutdownRequested()) return [];
    const out: string[] = [];
    for (let i = 0; i < LOCAL_AGENT_ACP_MODULES.length; i++) {
      if (isCliImmediateShutdownRequested()) return out;
      if (i > 0) {
        await yieldToEventLoop();
        if (isCliImmediateShutdownRequested()) return out;
      }
      const mod = LOCAL_AGENT_ACP_MODULES[i]!;
      try {
        if (await mod.detectLocalAgentPresence()) out.push(mod.BACKEND_LOCAL_AGENT_TYPE);
      } catch {
        /* skip */
      }
    }
    return out;
  } catch {
    return [];
  }
}
